<template>
  <div id="tempcreate-layer">
    <light-header :back="backUrl"></light-header>
    <div class="tempcreate-content auto">
      <div class="tempcreate-files">
<!--        <h3 class="tempcreate-title">-->
<!--          <span>个人实名认证</span>-->
<!--        </h3>-->
        <div style="display: flex; flex-wrap: wrap" id="company-info-layer">
        </div>
        <div v-if="!authOk">
          <div class="area-title">
            <span class="bar"></span>
            <span class="title">身份证信息</span>
          </div>
          <el-form
            :model="filesForm"
            ref="filesForm"
            label-width="80px"
            label-position="left"
            class="files-Form"
          >
            <div style="width: 100%; margin: 15px auto">
              <el-form-item
                prop="idName"
                label="姓名"
                :rules="[
                  {
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur',
                  },
                  { validator: checkChinese, trigger: 'blur' },
                ]"
              >
                <el-input
                  maxlength="4" show-word-limit size="small"
                  v-model="filesForm.idName"
                  placeholder="请输入姓名"
                  style="width: 680px;"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="idNumber"
                label="身份证号"
                :rules="[
                  {
                    required: true,
                    message: '请输入身份证号',
                    trigger: 'blur',
                  },
                  { validator: checkID, trigger: 'blur' },
                ]"
              >
                <el-input
                  maxlength="18" show-word-limit size="small"
                  v-model="filesForm.idNumber"
                  placeholder="请输入身份证号"
                  style="width: 680px"
                ></el-input>
              </el-form-item>
            </div>
            <div class="area-title">
              <span class="bar"></span>
              <span class="title">人脸认证</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="color: #86909c;font-size: 14px;font-weight: 400;margin-right: 20px;">
                身份证信息填写完成后，点击"开始认证"按钮，根据提示使用手机微信扫码二维码进行人脸认证
              </span>
              <el-button v-if="!authId"
                      type="primary" size="small"
                      @click="handleSavePersonalInfo"
                      :disabled="formLoading"
                      :loading="formLoading"
              >开始认证</el-button>
              <el-button v-if="qrcodeStatus == 'notAuth' || qrcodeStatus == 'expired'"
                         type="primary" size="small"
                         @click="handleSavePersonalInfo"
                         :disabled="formLoading"
                         :loading="formLoading"
              >重新认证</el-button>
            </div>
<!--            <el-form-item>-->
              <div class="handle-sign" v-if="authId">
                <img class="wexin" src="@/assets/images/sign/phone.png" alt="" width="450"
                     height="330">
                <div style="position: relative;top: 57px;left: 18px;">
                  请使用微信扫描下方二维码，根据提示完成人脸认证
                </div>
                <div style="position: absolute;top: 110px;left: 85px">
                  <img :src="authCodeImg" alt="" style="width: 130px;height: 130px;">
                </div>
                <div v-if="qrcodeStatus == 'expired'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                  <svg-icon iconClass="icon-yellow-warn"
                            style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                  <div style="position:absolute;margin-top: 74px;margin-left: 43px;color:#EFB040">已过期</div>
                </div>
                <div v-if="qrcodeStatus == 'notAuth'" style="position: absolute;top: 110px;left: 85px;background: #FFFFFF;width: 130px;height: 130px;border-radius: 6px 6px 6px 6px;opacity: 0.95;">
                  <svg-icon iconClass="icon-yellow-warn"
                            style="position:absolute;width: 30px;height: 30px;margin-top: 36px;margin-left: 50px;" />
                  <div style="position:absolute;margin-top: 74px;margin-left: 23px;color:#EFB040">人脸认证失败</div>
                </div>
                <el-button plain round size="mini"
                           style="position: absolute;top: 256px;left: 118px" @click="handleSavePersonalInfo">
                  刷新
                  <i class="el-icon-refresh-right"></i>
                </el-button>
              </div>
<!--            </el-form-item>-->
          </el-form>
<!--          <div v-else>-->
<!--            <div style="text-align: center">-->
<!--              <img :src="authCodeImg" alt="" />-->
<!--            </div>-->
<!--            <div class="qrcode-tip" v-if="!qrCodeOutDated">-->
<!--              请扫描二维码完成个人实名认证-->
<!--            </div>-->
<!--            <div class="qrcode-tip" v-else>二维码已失效！请重新获取</div>-->
<!--          </div>-->
        </div>

        <el-result
          v-else
          icon="success"
          title="认证成功"
          subTitle="返回首页进行更多操作">
          <template slot="extra">
            <el-button type="primary" size="small" @click="handleBackHome">返回首页</el-button>
          </template>
        </el-result>
      </div>
    </div>
<!--    <div class="tempcreate-users-box auto">-->
<!--      <div v-if="!authOk">-->
<!--        <div class="sign-btns" v-if="!authId">-->
<!--          <el-button-->
<!--            type="primary"-->
<!--            @click="handleSavePersonalInfo"-->
<!--            :disabled="formLoading"-->
<!--            :loading="formLoading"-->
<!--            >开始认证</el-button-->
<!--          >-->
<!--        </div>-->
<!--        <div class="sign-btns" v-else>-->
<!--          <el-button type="primary" @click="handleRefreshAuthQrcode"-->
<!--            >重新获取</el-button-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="sign-btns" v-else>-->
<!--        <el-button type="primary" @click="handleBackHome">返回首页</el-button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
// import { Loading } from "element-ui";

import lightHeader from "@/components/lightHeader";
import { getPersonAuthLink, getPersonAuthResult } from "@/api/auth/auth";
export default {
  components: {
    lightHeader,
  },
  computed: {
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      formLoading: false,

      filesForm: {
        idName: "",
        idNumber: "",
      },

      authCodeImg: "",
      authId: "",
      timer: null,
      authOk: false,
      qrCodeOutDated: false,
      qrcodeStatus: null,

      IdentityCodeValid(code) {
        code = code.toUpperCase();
        var city = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江 ",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北 ",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏 ",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外 "
        };
        var tip = "";
        var pass = true;

        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/i.test(code)) {
          //if(!code || !/(^\d{17}(\d|X|x)$)/i.test(code)){
          tip = "身份证号格式错误";
          pass = false;
        } else if (!city[code.substr(0, 2)]) {
          tip = "地址编码错误";
          pass = false;
        } else {
          //18位身份证需要验证最后一位校验位
          if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
              ai = code[i];
              wi = factor[i];
              sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
              tip = "校验位错误";
              pass = false;
            }
          }
        }
        //if(!pass) mui.toast(tip);
        return pass;
      },

      checkID: (rule, value, callback) => {
        if (!this.IdentityCodeValid(value)) {
          callback(new Error("身份证号输入有误！"));
        } else {
          callback();
        }
      },
      checkChinese: (rule, value, callback) => {
        var reg = /^[\u0391-\uFFE5]+$/;
        if (!reg.test(value)) {
          callback(new Error("只能输入中文！"));
        } else {
          callback();
        }
      },
    };
  },
  created() {},
  beforeRouteLeave(to, from, next) {
    if (this.timer) {
      setTimeout(() => {
        clearInterval(this.timer);
        this.timer = null;
      }, 0);
    }
    if (this.outTimer) {
      clearTimeout(this.outTimer);
      this.outTimer = null;
    }
    next();
  },
  methods: {
    handleSavePersonalInfo() {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          this.qrcodeStatus = null;
          this.formLoading = true;
          this.handleGetPersonAuthLink();
        }
      });
    },
    handleGetPersonAuthLink() {
      getPersonAuthLink({
        idName: this.filesForm.idName,
        idNumber: this.filesForm.idNumber,
        callbackUrl: "",
        needQrcode: "yes",
      })
        .then((res) => {
          this.formLoading = false;
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.authCodeImg = res.data.authLinkQrcodeBase64;
            this.authId = res.data.authId;
            this.pollingResult();
          }
        })
        .catch((err) => {
          this.formLoading = false;
          console.log(err);
        });
    },
    handleRefreshAuthQrcode() {
      this.handleGetPersonAuthLink();
    },
    pollingResult() {
      if(this.timer){
        clearInterval(this.timer);
        this.timer = null;
      }
      if(this.outTimer){
        clearTimeout(this.outTimer);
        this.outTimer = null;
      }
      this.qrCodeOutDated = false;
      this.timer = setInterval(this.getAuthResultHandle, 3000);
      this.outTimer = setTimeout(() => {
        clearInterval(this.timer);
        this.timer = null;
        this.qrCodeOutDated = true;
        this.qrcodeStatus = "expired";
      }, 1000 * 60 * 5);
      // }, 1000);
    },
    getAuthResultHandle() {
      getPersonAuthResult({
        authId: this.authId,
      })
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            if (res.data.status === "pass") {
              this.authOk = true;
              clearInterval(this.timer);
              this.timer = null;
            } else if (res.data.status === "notAuth") {
              this.authOk = false;
              // this.$message({
              //   showClose: true,
              //   message: "实人认证失败，请重新认证",
              //   type: "warning",
              // });
              clearInterval(this.timer);
              this.timer = null;
              this.qrcodeStatus = 'notAuth';
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleBackHome() {
      this.$router.replace("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.tempcreate-content {
  font-size: 14px;
  font-weight: 400;
  /*color: #333333;*/
  /*margin-top: 30px;*/
  /*background: #F3F3F7;*/
  /*min-height: calc(100vh);*/

  .tempcreate-files {
    background: #ffffff;
    min-height: calc(100vh);
    overflow: hidden;
    padding: 27px 27px;
    .tempcreate-title {
      height: 23px;
      line-height: 23px;
      font-size: 18px;
      color: #333333;
      border-left: 3px solid #3296fa;
      text-indent: 10px;
      font-weight: 400;
      margin-bottom: 22px;
    }
    label {
      width: 98px;
      color: #666666;
      display: inline-block;
    }
  }
}
.tempcreate-users-box {
  padding: 15px 40px;
  background: #ffffff;
  margin-top: 18px;

  .add-btn {
    padding: 11px 14px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
  }

  .sign-btns button.sign-button {
    padding: 12px 18px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }
}
#tempcreate-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.sign-btns {
  width: 718px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.sign-btns button {
  width: 140px;
  height: 45px;
  font-size: 14px;
}

#invoice-info-layer .el-form-item /deep/ .el-input__inner,
#invoice-info-layer .el-form-item /deep/ .el-form-item__content,
#invoice-info-layer .el-form-item /deep/ .el-date-editor,
#company-info-layer .el-form-item /deep/ .el-input__inner,
#company-info-layer .el-form-item /deep/ .el-form-item__content,
#company-info-layer .el-form-item /deep/ .el-date-editor {
  width: 300px !important;
}

h4 {
  padding: 10px 0 30px;
  text-align: center;
}
.el-divider /deep/ .el-divider__text {
  color: #999;
  text-align: center;
}

#auth-info-company-layer .el-form-item__label {
  font-size: 18px;
  line-height: 48px;
}

#auth-info-company-layer .submit {
  width: 363px;
  height: 50px;
  margin: 60px auto 0;
  font-size: 18px;
  margin-bottom: 96px;
}

#auth-info-company-layer .el-form-item {
  width: 55%;
  margin: 0 auto 20px;
}

#auth-info-company-layer .el-form-item /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: center;
}

.qrcode-tip {
  color: #000;
  font-size: 14px;
  text-align: center;
}

.area-title {
  .title {
    font-size: 15px;
    font-weight: 500;
    color: #313843;
  }

  .sub {
    font-size: 11px;
    font-weight: 400;
    color: #86909C;

    & + .sub {
      margin-left: 8px;
    }
  }
}

.handle-sign {
  width: 760px;
  height: 350px;
  background: #F7F8FA;
  position: relative;
  margin-top: 15px;

  .wexin {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
